<template>
  <section class="page-block services-block">
    <div class="wide">
      <div class="mid">
        <div class="narrow">
          <div class="list barbers">
            <p class="title">{{ $t('ServicesBlock.ServicesBarbers.Title') }}
              <span :style="{'background-image': 'url(' + require('@/i/services/line-end-1.svg') + ')'}"></span>
            </p>
            <p class="legend">
              <label>{{ $t('ServicesBlock.ServicesBarbers.LegendA') }}</label>
              <span :style="{'background-image': 'url(' + require('@/i/services/line-end-1.svg') + ')'}"></span>
              <label>{{ $t('ServicesBlock.ServicesBarbers.LegendB') }}</label>
              <label>{{ $t('ServicesBlock.ServicesBarbers.LegendC') }}</label>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.A') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Aprice') }}</div>&nbsp;₴</span>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.AAprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.B') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Bprice') }}</div>&nbsp;₴</span>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.BBprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.C') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Cprice') }}</div>&nbsp;₴</span>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.CCprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.D') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Dprice') }}</div>&nbsp;₴</span>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.DDprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.E') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Eprice') }}</div>&nbsp;₴</span>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.EEprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.F') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Fprice') }}</div>&nbsp;₴</span>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.FFprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.G') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Gprice') }}</div>&nbsp;₴</span>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.GGprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.H') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Hprice') }}</div>&nbsp;₴</span>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.HHprice') }}</div>&nbsp;₴</span>
            </p>
          </div>
          <div class="discouts">
            <span>{{ $t('ServicesBlock.ServicesDiscounts.Title') }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'service-block',
  components: {
  },
  props: {
  }
}
</script>
